// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Tu configuración web de Firebase, copiada desde la consola
const firebaseConfig = {
    apiKey: "AIzaSyCBJLFkGGUIIDxXVuaP0ANZEPGf4CsAOG4",
    authDomain: "kifli-tracker.firebaseapp.com",
    projectId: "kifli-tracker",
    storageBucket: "kifli-tracker.firebasestorage.app",
    messagingSenderId: "466789068961",
    appId: "1:466789068961:web:b5e847797d7233227ac0e0"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Exporta la instancia de la base de datos de Firestore
export const db = getFirestore(app);